import React from 'react';

let did = false;
const ensure = () => {
  if (did || typeof document === 'undefined') return;
  did = true;
  const s = document.createElement('style');
  s.dataset.pl = 'wordmark';
  s.textContent = `
.pl-wordmark{display:inline-flex;align-items:center;gap:var(--pl-s-4);min-width:0;color:var(--pl-ink);
  font-family:var(--pl-font-mono);font-weight:var(--pl-w-semi);line-height:1;
  letter-spacing:var(--pl-track-kpi)}
.pl-wordmark--light{color:var(--pl-chrome-accent)}
.pl-wordmark__mark{flex:none;display:block;fill:currentColor}
.pl-wordmark__text{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}
`;
  document.head.appendChild(s);
};

/* The target-tick mark on a 48 grid: a 30x30 square frame, 4 thick, at (9,9),
   plus a 5x44 tick at x=26,y=2. Square corners. See BRAND-LOCK.md "Logo". */
const MARK = (
  <React.Fragment>
    <path fillRule="evenodd" d="M9 9h30v30H9zM13 13v22h22V13z" />
    <rect x="26" y="2" width="5" height="44" />
  </React.Fragment>
);

export function Wordmark({ size = 19, tone = 'ink', mark = true, className = '', ...rest }) {
  ensure();
  const markSize = Math.round(size * 1.16);
  const cls = ['pl-wordmark', tone === 'light' ? 'pl-wordmark--light' : '', className]
    .filter(Boolean).join(' ');
  return (
    <span className={cls} {...rest}>
      {mark ? (
        <svg className="pl-wordmark__mark" viewBox="0 0 48 48" width={markSize} height={markSize}
             aria-hidden="true">{MARK}</svg>
      ) : null}
      <span className="pl-wordmark__text" style={{ fontSize: size }}>pleach</span>
    </span>
  );
}
